module.exports = __webpack_public_path__ + "static/media/feature.b6a98222.jpeg";